import styles from './language-select.scss';
import EnglishPNG from '@/images/png/english_flag.png';
import DanishPNG from '@/images/png/danish_flag.png';

import React, { useState } from 'react';
import { FormSelect } from 'react-bootstrap';
import i18n from 'i18next';

import classnames from 'classnames/bind';
import { LanguageCodes, LANGUAGE, LanguageTypes } from '@/constants/system';

const cx = classnames.bind(styles);

type LanguageSelectProps = {
  // PD-3030 follow-up: the form-field look, for a page that places the control
  // in a form grid column (the profile page). The select becomes a visible box
  // (1px border, the light fill of the other inputs) and the wrapper fills its
  // column instead of taking 24% of it. Off by default: the login page and the
  // consent gate keep the borderless look they have always had.
  bordered?: boolean;
};

const LanguageSelect = ({ bordered = false }: LanguageSelectProps) => {
  const languageList = Object.keys(LanguageCodes);
  const [currentLanguage, setCurrentLangulage] = useState(i18n.language);

  const changeLanguage = (event: { target: HTMLSelectElement }) => {
    const language = event.target.value;

    setCurrentLangulage(language);
    localStorage.setItem(LANGUAGE, language);
    i18n.changeLanguage(language);
  };

  return (
    <div
      className={cx(['d-flex align-items-center', 'languageSelect'], {
        fullWidth: bordered,
      })}>
      {currentLanguage === LanguageTypes.en ? (
        <img className={styles.languageFlag} src={EnglishPNG} />
      ) : (
        <img className={styles.languageFlag} src={DanishPNG} />
      )}
      <FormSelect
        className={
          bordered
            ? cx(['bordered', 'select-input-bg-color', 'hover'])
            : 'border-0 hover'
        }
        aria-label="Default select example"
        value={currentLanguage}
        onChange={(event: { target: HTMLSelectElement }) => {
          changeLanguage(event);
        }}>
        {languageList.map(item => (
          <option key={item} value={item}>
            {LanguageCodes[item]}
          </option>
        ))}
      </FormSelect>
    </div>
  );
};

export default LanguageSelect;
